import React from "react";
import { Badge } from "react-bootstrap";
import { history } from "../../redux/configureStore";
import { FaIcon } from "../../lib/FaIcon";

export const Pill = ({
  onClick,
  text,
  title,
  isActive,
  variant,
  margin = "mr-1",
  padding = "p-2",
  className = "",
  cursor = "cursor-pointer",
  icon,
}) => {
  const bg = isActive ? `bg-${variant} text-white` : `bg-none border border-${variant}`;

  return (
    <Badge pill className={`${margin} font-weight-normal ${cursor} ${padding} ${bg} ${className}`} onClick={onClick}>
      <span title={title}>
        {text}
        {icon && <FaIcon icon={icon} align="" />}
      </span>
    </Badge>
  );
};

export const NavBadge = (props) => <Pill {...props} onClick={() => history.push(props.to)} />;
